// Import SCSS (Vite automaticky zpracuje)
import '../scss/main.scss';

// Import menu functionality
import { initMenu } from './menu.js';

document.addEventListener('DOMContentLoaded', () => {
  initMenu();
});
